import { render, staticRenderFns } from "./PlayerView.vue?vue&type=template&id=c23290e8&scoped=true"
import script from "./PlayerView.vue?vue&type=script&lang=js"
export * from "./PlayerView.vue?vue&type=script&lang=js"
import style0 from "./PlayerView.vue?vue&type=style&index=0&id=c23290e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c23290e8",
  null
  
)

export default component.exports